import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Grid
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../common/formik/FormikButton';
import FormikTextField from '../../common/formik/FormikTextField';
import { Supplier } from '../supplier/Supplier.interface';
import { useCreateScar, useGetSupplierList } from './Scar.hook';
import { Scar } from './Scar.interface';
import SupplierSelector from '../supplier/components/SupplierSelector';

export const scarValidationSchema = Yup.object({
  supplierId: Yup.string().required('Required'),
  description: Yup.string().required('Required')
});

export type ScarCreateDialogProps = DialogProps & {
  supplierId?: number;
  disableSupplierSelect?: boolean;
  onCancel?: () => void;
  onCreate?: (scar: Scar) => void;
};

export const ScarCreateDialog: React.FC<ScarCreateDialogProps> = props => {
  const {
    supplierId = -1,
    disableSupplierSelect = false,
    onCancel,
    onCreate,
    ...dialogProps
  } = props;
  const formikRef = useRef<FormikValues>();
  const [{ error, isLoading, data }, post] = useCreateScar();
  const initialValues: Partial<Scar> = {
    supplierId,
    description: ''
  };

  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [{ data: supplierList }, get] = useGetSupplierList();

  useEffect(() => {
    get();
  }, [get]);

  useEffect(() => {
    supplierList && setSuppliers(supplierList.data);
  }, [supplierList]);

  useEffect(() => {
    if (!isLoading && data) {
      onCreate?.(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  return (
    <Dialog {...dialogProps}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={initialValues}
        validationSchema={scarValidationSchema}
        onSubmit={value => post({ ...value })}
      >
        {({ values, setFieldValue }) => (
          <Form autoComplete='off'>
            <DialogTitle>New SCAR</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <SupplierSelector
                    value={disableSupplierSelect ? supplierId : values.id}
                    disabled={disableSupplierSelect}
                    onChange={(supplier: Supplier | null) => {
                      setFieldValue('supplierId', supplier?.id, true);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField
                    name='description'
                    label='Problem Description'
                    multiline
                  />
                </Grid>
              </Grid>
              {error && (
                <Alert severity='error'>Error occurred. {error.message}</Alert>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={onCancel}>Cancel</Button>
              <FormikButton>Create</FormikButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ScarCreateDialog;
